interface MobiusConfig {
  identityToken: string;
}

export const mobiusConfig: MobiusConfig = {
  identityToken: '11a86905-d823-4fd9-921e-662d9937cb8e',
};
